module.exports = __webpack_public_path__ + "img/icon-slide1.0c21951d.jpg";